import styled from 'styled-components';

export const Container = styled.div``;

export const InfoHours = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors?.text?.secondary || theme.colors?.text?.primary};
  margin: 0 0 1rem 0;
  padding: 0.75rem;
  background-color: ${({ theme }) => theme.colors?.gray01 || '#f5f5f5'};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors?.gray02 || '#ddd'};

  strong {
    font-weight: 600;
  }
`;

export const ContainerFocus = styled.div`
  display: grid;

  padding: 1rem 0;
`;

export const InputFile = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${({ theme }) => theme.colors?.primary};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors?.backgroundColor};

  cursor: pointer;
  margin-top: 0.5rem;

  max-width: 15rem;
  width: 100%;
  height: 3rem;
`;

export const InputText = styled.span`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  color: ${({ theme }) => theme.colors?.text.tertiary};
`;

export const NameDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  input[type='file'] {
    display: none;
  }
`;

export const Text = styled.div`
  width: 100%;

  text-overflow: ellipsis;
  overflow: hidden;

  white-space: nowrap;
`;

export const ButtonsDiv = styled.div`
  display: flex;
  justify-content: end;

  width: 9rem;

  gap: 1rem;
`;

export const ButtonDownload = styled.a`
  color: ${({ theme }) => theme.colors?.primary};
  cursor: pointer;
`;

export const ButtonSave = styled.div`
  color: ${({ theme }) => theme.colors?.success};
  cursor: pointer;
`;

export const ButtonDelete = styled.div`
  color: ${({ theme }) => theme.colors?.danger};
  cursor: pointer;
  padding-left: 1rem;
`;

export const Card = styled.div`
  position: relative;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 10px 10px 10px 20px;
  overflow: hidden;
  margin-bottom: 5px;

  display: flex;
  flex-wrap: wrap;

  gap: 1rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.xxlarge}) {
    flex-direction: column; // 👈 agora empilha os filhos verticalmente
    flex-wrap: nowrap; // 👈 desativa o wrap pra garantir coluna única
  }
`;

interface IconCardProps {
  situation: 'aguardando' | 'aprovado' | 'reprovado' | 'Concluído';
}

export const IconCard = styled.div<IconCardProps>`
  position: absolute;

  left: 0;
  top: 0;
  bottom: 0;
  width: 0.8rem;

  background-color: ${({ theme, situation }) => {
    switch (situation) {
      case 'aguardando':
        return theme.colors?.gray03;
      case 'aprovado':
      case 'Concluído':
        return theme.colors?.aqua;
      case 'reprovado':
        return theme.colors?.danger;
      default:
        return theme.colors?.gray03;
    }
  }};
`;

interface CardSectionProps {
  width?: string;
}

export const CardSection = styled.div<CardSectionProps>`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => width || '100%'};

  @media screen and (max-width: ${({ theme }) => theme.size?.xxlarge}) {
    width: 100%;
  }
`;

export const Label = styled.label`
  margin-bottom: 4px;
`;

export const CardSectionFullWidth = styled(CardSection)`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
